@if (sessionPackagesAvailable) {
    <div class="session-bingo-outer-container">
        <div class="session-bingo-data" [class.no-filter-items]="!(sessionItemsList && sessionItemsList.length > 0)">
            <div class="session-header-container" id="time-wise">
                @if (sessionItemsList && sessionItemsList.length > 0) {
                    <div class="session-list-container">
                        <div #daysLiterFilterDropdown class="day-select" (click)="toggleDayListDropdown()">
                            <span>{{ selectedDay > -1 ? days[selectedDay] : '-' }}</span>
                            <span class="theme-playbutton-no-outline"></span>
                            @if (showDaysListDropdown) {
                                <div class="days-list">
                                    @for (day of days; track day; let i = $index) {
                                        @if (weeklySchedule[i] && weeklySchedule[i].length > 0) {
                                            <div class="days-list-item" (click)="onDaysFilterSelect(i)">
                                                {{ day }}
                                            </div>
                                        }
                                    }
                                </div>
                            }
                        </div>
                        @for (header of headers; track header) {
                            <div
                                class="session"
                                [ngClass]="header.isActive ? 'active-session' : header.isDisabled ? 'disable-session' : ''"
                                (click)="selectSession(header.splitNumber)">
                                <div class="parts">
                                    {{ header.title }}
                                </div>
                                <div class="session-time">
                                    {{ header.startHours | number: '2.0-0' }}:{{ header.startMinutes | number: '2.0-0' }} -
                                    {{ header.endHours | number: '2.0-0' }}:{{ header.endMinutes | number: '2.0-0' }}
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
            <div class="packages-filter">
                <span class="filter-text">{{ content.filter }}</span>
                <bg-bingo-packages-filter
                    [packageFilterItems]="packageFilterItems"
                    [selectedFilterItem]="selectedFilterItem"
                    (selectItem)="filterOptionClicked($event)" />
            </div>
            @if (!displaynosession && selectedDay > -1) {
                <div class="session-body-outer-container">
                    <div class="session-body-container">
                        @if (sessionItemsList && sessionItemsList.length > 0 && weeklySchedule[selectedDay].length > 0) {
                            <div class="sessions">
                                <!-- <ngu-carousel #sessionListCarousel [inputs]="config" [dataSource]="weeklySchedule[i]"> -->
                                @for (data of weeklySchedule[selectedDay]; track data) {
                                    <!-- <div class="session-container" [class.session-bingo-nextline]="bingoMultiline"> -->
                                    <bg-bingo-package-item #sessions [id]="data.id"></bg-bingo-package-item>
                                    <!-- </div> -->
                                }
                                <!-- <button NguCarouselPrev class="theme-left home-room-button-left"
                                    [hidden]='sessionListCarousel.isFirst'></button>
                                <button *ngIf="weeklySchedule[i].length>4" NguCarouselNext
                                    class="theme-right home-room-button-right"
                                    [hidden]='sessionListCarousel.isLast'></button> -->
                            </div>
                        }
                    </div>
                </div>
            }
            @if ((!displaynosessionMessage && !sessionsLoading) || !sessionItemsList.length) {
                <div class="no-filtered-packages-available">
                    <span>{{ content.NoSessions }}</span>
                </div>
            }
            @if (sessionsLoading) {
                <div class="no-session-available">
                    {{ content?.SessionLoading }}
                </div>
            }
        </div>
    </div>
} @else {
    @if (sessionsLoading) {
        <div class="no-packages-available">
            {{ content?.SessionLoading }}
        </div>
    } @else if (!sessionPackagesAvailable && !sessionsLoading) {
        <div class="no-packages-available">
            {{ content?.NoSessions }}
        </div>
    }
}
